// extracted by mini-css-extract-plugin
module.exports = {"section":"Sect3_Comp2_section__3QvKA","content":"Sect3_Comp2_content__3U6C0"};